import { render, staticRenderFns } from "./Mainboard.vue?vue&type=template&id=7b43c4a8&"
import script from "./Mainboard.vue?vue&type=script&lang=js&"
export * from "./Mainboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports